(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-clientas"] && !Shopify.designMode) return;
  try {
    
  function testimoniosInitCarousel(wrapper) {
    if (wrapper.dataset.testimoniosReady === 'true') return;
    wrapper.dataset.testimoniosReady = 'true';

    var track = wrapper.querySelector('[data-testimonios-track]');
    var prevBtn = wrapper.querySelector('[data-testimonios-prev]');
    var nextBtn = wrapper.querySelector('[data-testimonios-next]');
    var dotsWrapper = wrapper.querySelector('[data-testimonios-dots]');
    var dots = dotsWrapper ? Array.prototype.slice.call(dotsWrapper.querySelectorAll('[data-testimonios-dot]')) : [];
    var cards = track ? Array.prototype.slice.call(track.children) : [];

    if (!track || !cards.length) return;

    var step = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].offsetWidth;

    function updateControls() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var scrollable = maxScroll > 4;

      if (prevBtn) prevBtn.style.display = scrollable ? '' : 'none';
      if (nextBtn) nextBtn.style.display = scrollable ? '' : 'none';
      if (dotsWrapper) dotsWrapper.style.display = scrollable ? '' : 'none';

      if (scrollable) {
        if (prevBtn) prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 4);
        if (nextBtn) nextBtn.classList.toggle('is-disabled', track.scrollLeft >= maxScroll - 4);
      }
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function scrollToIndex(index) {
      var card = cards[index];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        scrollToIndex(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var closest = 0;
        var closestDistance = Infinity;
        cards.forEach(function (card, i) {
          var distance = Math.abs((card.offsetLeft - track.offsetLeft) - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        setActiveDot(closest);
        updateControls();
        ticking = false;
      });
    });

    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      track.scrollLeft = startScroll - delta;
    });
    function stopDrag() {
      isDown = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', stopDrag);
    track.addEventListener('pointercancel', stopDrag);
    track.addEventListener('pointerleave', stopDrag);

    window.addEventListener('resize', updateControls);
    updateControls();
  }

  function testimoniosInitAll(root) {
    (root || document).querySelectorAll('[data-testimonios-carousel]').forEach(testimoniosInitCarousel);
  }

  testimoniosInitAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    testimoniosInitAll(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
